exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#date-calculator-modal .duration-display{display:flex;align-items:center;justify-content:space-between}", ""]);

